import { z } from 'zod';

/**
 * Validation schema for the Sport step.
 * Ensures a sport has been selected.
 */
export const sportStepSchema = z.object({
  sport: z.object({
    uid: z.string().min(1, 'Debes seleccionar un deporte'),
    name: z.string().min(1),
  }),
});

export type SportStepData = z.infer<typeof sportStepSchema>;
